import { useMemo } from 'react';
import { resolveRichText } from '@vibesites/runtime';
import { EditableToken, useContentToken, useProperty } from '@vibesites/runtime/react';
import { keepLocationTogether, keepPropertyNameTogether, stripWrappingParagraph } from '../../utils/keepLocationTogether';
import { INNER_PAGE_HERO_SUBTITLE_CLASS } from './InnerPageHeroSection';

interface InnerPageHeroSubtitleProps {
  path: string;
}

export function InnerPageHeroSubtitle({ path }: InnerPageHeroSubtitleProps) {
  const property = useProperty();
  const rawHtml = useContentToken(path);

  const resolvedHtml = useMemo(() => {
    if (!rawHtml) return '';
    let html = resolveRichText(rawHtml, property as Record<string, any>);
    html = stripWrappingParagraph(html);
    html = keepPropertyNameTogether(html, property.property_name as string | null | undefined);
    return keepLocationTogether(
      html,
      property.property_address_city as string | null | undefined,
      property.property_address_state as string | null | undefined,
    );
  }, [rawHtml, property]);

  return (
    <EditableToken path={path} type="richtext" as="h2" className={INNER_PAGE_HERO_SUBTITLE_CLASS}>
      <span
        data-vibesite-richtext=""
        dangerouslySetInnerHTML={{ __html: resolvedHtml }}
        style={{ display: 'contents' }}
      />
    </EditableToken>
  );
}
